import React from 'react';
import classNames from 'classnames';
var ThermometerSegment = function (_a) {
    var widthPercent = _a.widthPercent, severity = _a.severity, tooltipId = _a.tooltipId;
    return (React.createElement("div", { className: classNames('thermometer__segment', "thermometer__segment--" + severity), style: { width: widthPercent }, "data-tip": widthPercent, "data-for": tooltipId }));
};
export default ThermometerSegment;
//# sourceMappingURL=ThermometerSegment.js.map